"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.promise.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ImageDropzone = _interopRequireDefault(require("../shared/elements/imageUpload/ImageDropzone"));

var _ImageCropper = _interopRequireDefault(require("../shared/elements/imageUpload/ImageCropper"));

var _ImageDisplay = _interopRequireDefault(require("../shared/elements/imageUpload/ImageDisplay"));

var _LoaderComponent = _interopRequireDefault(require("../shared/elements/LoaderComponent"));

var _UniversalDashModal = _interopRequireDefault(require("../shared/elements/UniversalDashModal"));

require("./ImageHandler.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ImageHandler = function ImageHandler(props) {
  var currentImg = props.currentImg,
      _props$dropzoneTitle = props.dropzoneTitle,
      dropzoneTitle = _props$dropzoneTitle === void 0 ? 'Drag and drop a photo here' : _props$dropzoneTitle,
      _props$dropzoneBtnTex = props.dropzoneBtnText,
      dropzoneBtnText = _props$dropzoneBtnTex === void 0 ? 'Upload Photo' : _props$dropzoneBtnTex,
      _props$dropzoneSubtit = props.dropzoneSubtitle,
      dropzoneSubtitle = _props$dropzoneSubtit === void 0 ? 'Photo of decedent must be at least 300px by 200px' : _props$dropzoneSubtit,
      _props$dropzoneMinWid = props.dropzoneMinWidth,
      dropzoneMinWidth = _props$dropzoneMinWid === void 0 ? 300 : _props$dropzoneMinWid,
      _props$dropzoneMinHei = props.dropzoneMinHeight,
      dropzoneMinHeight = _props$dropzoneMinHei === void 0 ? 200 : _props$dropzoneMinHei,
      _props$dropzoneMultip = props.dropzoneMultiple,
      dropzoneMultiple = _props$dropzoneMultip === void 0 ? true : _props$dropzoneMultip,
      _props$dropzoneDefaul = props.dropzoneDefaultIcon,
      dropzoneDefaultIcon = _props$dropzoneDefaul === void 0 ? false : _props$dropzoneDefaul,
      _props$modalTitle = props.modalTitle,
      modalTitle = _props$modalTitle === void 0 ? 'Crop Image' : _props$modalTitle,
      _props$cropperHeight = props.cropperHeight,
      cropperHeight = _props$cropperHeight === void 0 ? 385 : _props$cropperHeight,
      _props$modalBtnText = props.modalBtnText,
      modalBtnText = _props$modalBtnText === void 0 ? 'Save' : _props$modalBtnText,
      _props$modalSecondary = props.modalSecondaryBtnText,
      modalSecondaryBtnText = _props$modalSecondary === void 0 ? 'Cancel' : _props$modalSecondary,
      handleRemoveImage = props.handleRemoveImage,
      handleUploadFinish = props.handleUploadFinish,
      v11Styling = props.v11Styling,
      v11InviteStyling = props.v11InviteStyling;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      cropperOpen = _useState2[0],
      setCropperOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      imageCropperSrc = _useState4[0],
      setImageCropperSrc = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      imageName = _useState6[0],
      setImageName = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isUploading = _useState8[0],
      setIsUploading = _useState8[1];

  var overrideDefaultStyling = v11Styling || v11InviteStyling;
  var cropper = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setImageCropperSrc(currentImg);
  }, [currentImg]);

  var toggleCropper = function toggleCropper(state) {
    var nextCropperState = typeof state !== 'undefined' ? state : !cropperOpen;
    setCropperOpen(nextCropperState);
  };

  var preCrop = function preCrop() {
    setIsUploading(true);
  };

  var handleCrop = function handleCrop() {
    cropper.current.crop();
  };

  var handleDrop = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var files,
          file,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              files = _args.length > 0 && _args[0] !== undefined ? _args[0] : [{}];
              file = files[0] || {};
              setCropperOpen(true);
              setImageCropperSrc(file.preview);
              setImageName(file.name);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDrop() {
      return _ref.apply(this, arguments);
    };
  }();

  var onUploadFinish = function onUploadFinish(url) {
    handleUploadFinish(url);
    setCropperOpen(false);
    setImageCropperSrc(url);
    setIsUploading(false);
  };

  var dropzoneClasses = (0, _classnames.default)('dash-image-handler', {
    'v11-invite-styling': v11InviteStyling
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: dropzoneClasses
  }, currentImg === '' ? /*#__PURE__*/_react.default.createElement(_ImageDropzone.default, {
    v11Styling: v11Styling,
    v11InviteStyling: v11InviteStyling,
    v3Styling: overrideDefaultStyling ? false : true,
    handleDrop: handleDrop,
    title: dropzoneTitle,
    buttonText: dropzoneBtnText,
    subtitle: dropzoneSubtitle,
    defaultIcon: dropzoneDefaultIcon,
    minWidth: dropzoneMinWidth,
    minHeight: dropzoneMinHeight,
    multiple: dropzoneMultiple
  }) : /*#__PURE__*/_react.default.createElement(_ImageDisplay.default, {
    imageUrl: currentImg,
    editFn: function editFn() {
      return toggleCropper(true);
    },
    removeFn: handleRemoveImage
  }), cropperOpen && /*#__PURE__*/_react.default.createElement(_UniversalDashModal.default, {
    v3Styling: true,
    headerTitle: modalTitle,
    mainButtonText: modalBtnText,
    mainButtonFn: handleCrop,
    secondaryButtonText: modalSecondaryBtnText,
    secondaryButtonFn: function secondaryButtonFn() {
      return toggleCropper(false);
    },
    closeModal: function closeModal() {
      return toggleCropper(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_ImageCropper.default, {
    handleUpload: onUploadFinish,
    height: cropperHeight,
    imageName: imageName,
    imageSrc: imageCropperSrc,
    preCrop: preCrop,
    ref: cropper
  })), isUploading && /*#__PURE__*/_react.default.createElement(_LoaderComponent.default, null));
};

var string = _propTypes.default.string,
    bool = _propTypes.default.bool,
    number = _propTypes.default.number,
    func = _propTypes.default.func;
ImageHandler.propTypes = {
  currentImg: string.isRequired,
  dropzoneTitle: string,
  dropzoneBtnText: string,
  dropzoneSubtitle: string,
  dropzoneMinWidth: number,
  dropzoneMinHeight: number,
  dropzoneMultiple: bool,
  dropzoneDefaultIcon: bool,
  modalTitle: string,
  cropperHeight: number,
  modalBtnText: string,
  modalSecondaryBtnText: string,
  handleRemoveImage: func.isRequired,
  handleUploadFinish: func.isRequired
};
var _default = ImageHandler;
exports.default = _default;